import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { moduleActionContext } from '@/store';
const roomModule = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default roomModule;
export const roomModuleActionContext = (context) => moduleActionContext(context, roomModule);
